import { render, staticRenderFns } from "./SummaryByCategory.vue?vue&type=template&id=ee06705a&"
import script from "./SummaryByCategory.vue?vue&type=script&lang=js&"
export * from "./SummaryByCategory.vue?vue&type=script&lang=js&"
import style0 from "./SummaryByCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports